export const preList1 = [
    {
      title: 'GF60绿色金融奖揭晓在即 谁将问鼎绿色金融发展标杆',
      date: '2022-12-22',
      source: '新京报 ',
      imgUrl: 'https://gf60.org.cn/upload/owe/6661e4fcf8554933ac990e9b158613f3.jpeg',
      link: 'https://m.life.china.com/2022-12/22/content_174334.html'
    },
    {
      title: '2022绿色金融国际峰会•滇池论坛开幕在即 多项绿色领域成果即将发布',
      date: '2022-12-21',
      source: '新华财经',
      imgUrl: 'https://gf60.org.cn/upload/owe/fa146a0430934a5880e85c34a6e54fcb.jpeg',
      link: 'https://bm.cnfic.com.cn/sharing/share/articleDetail/164494108/1'
    },
    {
      title: '资本市场服务“双碳”战略 推动完善绿色金融标准',
      date: '2022-11-15',
      source: '证券日报 ',
      imgUrl: 'https://gf60.org.cn/upload/owe/56c5ba17567349139e323e45ecb7ad36.jpeg',
      link: 'http://finance.china.com.cn/esg/20221115/5901128.shtml'
    },
    {
      title: '央行副行长宣昌能：用好用足金融政策支持绿色低碳转型',
      date: '2022-11-14',
      source: '中国经济网 ',
      imgUrl: 'https://gf60.org.cn/upload/owe/757c907df69541a2833181a187f7a52b.jpeg',
      link: 'https://baijiahao.baidu.com/s?id=1749433012269306413&wfr=spider&for=pc'
    },
    {
      title: 'GF60首席经济学家张俊杰：气候金融是实现全球气候目标的关键驱动力',
      date: '2022-11-11',
      source: 'GF60公众号',
      imgUrl: 'https://gf60.org.cn/upload/owe/c7451e52818747d6983d526b854498ae.jpeg',
      link: 'https://mp.weixin.qq.com/s/593vdE6i5GnFrHgN5UtYFQ'
    },
    {
      title: '我国ESG主题基金规模超两千亿元 A股公司信息披露率超三成',
      date: '2022-11-09',
      source: '新京报 ',
      imgUrl: 'https://gf60.org.cn/upload/owe/8e1984c6e59d446e9f84a1f3707c1205.jpeg',
      link: 'https://baijiahao.baidu.com/s?id=1748989181507615660&wfr=spider&for=pc'
    },
    {
      title: '中国环境保护产业协会党委书记郭承站：缓解能源供需矛盾降低能源安全风险，环保产业肩负重要使命',
      date: '2022-11-07',
      source: '中国环境 ',
      imgUrl: 'https://gf60.org.cn/upload/owe/4b2538df855342fd8adb802941cd344b.jpeg',
      link: 'https://www.cenews.com.cn/news.html?aid=1016513'
    },
    {
      title: '上海财经大学校长刘元春：金融科技将为企业低碳转型发展提供全新技术支持',
      date: '2022-11-11',
      source: '上海证券报',
      imgUrl: 'https://gf60.org.cn/upload/owe/107fe7a7daa14016961e7e7611353316.jpeg',
      link: 'https://news.cnstock.com/news,bwkx-202210-4973104.htm'
    },
    {
      title: '中国工程院院士、上海市政协副主席黄震：先立后破，“双碳”要循序而进',
      date: '2022-10-25',
      source: '澎湃 ',
      imgUrl: 'https://gf60.org.cn/upload/owe/03a2555234c54432975ec9d24527bd28.jpeg',
      link: 'https://m.thepaper.cn/baijiahao_20464156'
    },
    {
      title: '亚洲开发银行前首席气候变化专家吕学都：气候投融资的发展现状、问题与推进建议',
      date: '2022-08-22',
      source: 'GF60公众号',
      imgUrl: 'https://gf60.org.cn/upload/owe/2ef11c2e614344debb0d5a36c2487c01.jpeg',
      link: 'https://mp.weixin.qq.com/s/zbQgJfrq41HjzLyElGPdXA'
    },
    {
      title: 'GF60学术委员会委员刘明康：ESG不可能再等待下去',
      date: '2022-08-03',
      source: 'GF60公众号 ',
      imgUrl: 'https://gf60.org.cn/upload/owe/89dec94187ac4ad6bf52964c74cb17de.jpeg',
      link: 'https://mp.weixin.qq.com/s/Y0xyNp2yZXBjc9EVGyU2nQ'
    },
    {
      title: 'GF60学术委员会委员刘明康：拥抱数字化时代，做好ESG的统筹建设',
      date: '2022-07-27',
      source: 'GF60公众号 ',
      imgUrl: 'https://gf60.org.cn/upload/owe/393605be267d4c50b7f932866caf30eb.jpeg',
      link: 'https://mp.weixin.qq.com/s/M42eVctnzGpZ0B8hPUB0bA'
    },
    {
      title: '农业银行董事长谷澍：全力服务经济社会绿色低碳转型',
      date: '2022-03-11',
      source: '新华财经',
      imgUrl: 'https://gf60.org.cn/upload/owe/c4505af232ae4fce9f466b3fbece57ca.jpeg',
      link: 'https://baijiahao.baidu.com/s?id=1727004269973742111&wfr=spider&for=pc/'
    },
    {
      title: '工商银行董事长陈四清：四方着手，提升金融助力全球绿色转型发展的能力',
      date: '2022-01-17',
      source: '上海证券报 ',
      imgUrl: 'https://gf60.org.cn/upload/owe/6dacf544f103498eb5086e124d2d5a0c.jpeg',
      link: 'https://news.cnstock.com/news,yw-202201-4813685.htm'
    }
  ];
export const preList2 = [
    {
      title: 'GF60首席经济学家张俊杰：气候投融资需构建起标准、数据、产品、政策四大基础',
      date: '2022-11-17',
      source: '新华财经',
      imgUrl: 'https://gf60.org.cn/upload/owe/95d91d8ff66341ffae2a31600cd0964f.png',
      link: 'https://bm.cnfic.com.cn/sharing/share/articleDetail/164039485/1'
    },
    {
      title: '上海环境能源交易所董事长赖晓明：稳中求进建设全国统一碳市场',
      date: '2022-09-30',
      source: '新华财经',
      imgUrl: 'https://gf60.org.cn/upload/owe/09fd18ddf2fa4e2c9ea6275c29d87d9b.jpeg',
      link: 'https://bm.cnfic.com.cn/sharing/share/articleDetail/63469067/1'
    }
  ];
/*
export const meetingList = {
    am: [
      {
        time: '08:30-09:00',
        title: '嘉宾签到'
      },
      {
        time: '09:00-09:30',
        title: '开场及致辞',
        // list: ['云南省人民政府领导致辞', '昆明市委领导致辞', '昆明市人民政府领导致辞']
      },
      {
        title: '主持人：中共昆明市委常委、副市长 安恩法',
        list: ['云南省人民政府副省长张治礼致辞', '中共昆明市委副书记刘申寿致辞']
      },
      {
        time: '09:30-12:00',
        title: '主题演讲',
        list: [
          '刘明康|GF60学术委员会委员、原中国银监会主席',
          '陈四清|中国工商银行党委书记、董事长',
          '黄震|中国工程院院士、上海市政协副主席',
          '刘元春|上海财经大学校长',
          '廖媛媛|中国银保监会国际合作与外资机构监管部主任',
          '张光平|上海市政府参事、上海银保监局原一级巡视员',
          '孙念瑞|中国上市公司协会党委委员、副会长',
          '李辉|深圳证券交易所党委委员、副总经理',
          '张旭光|中国农业银行党委委员、执行董事、副行长',
          '杜春野|中国邮政储蓄银行党委委员、副行长',
          '何海峰|国泰君安首席经济学家'
        ]
      },
      {
        time: '12:00-14:00',
        title: '午餐',
        needAlign: true,
      }
    ],
    pm: [
      {
        time: '14:00-14:10',
        title: '金融支持磨憨建设签约仪式'
      },
      {
        time: '14:10-14:20',
        title: '绿色低碳产业发展股权投资基金落地启动仪式',
      },
      {
        time: '14:20-14:40',
        title: '指数及行业报告发布',
        list: ['中证金司南气候友好主题指数发布仪式', 'GF60首席经济学家张俊杰解读指数编制报告']
      },

      {
        time: '14:40-15:15',
        title: '主旨演讲与圆桌讨论一',
        list: [
          '王海璐|工银理财有限责任公司党委书记、董事长',
          '段兵|农银理财党委副书记、总裁',
          '孙琦|中国风险投资有限公司合伙人'
          // '主持|：',
          // '尹彬彬|GF60绿色金融业务委员会主任',
          // '嘉宾|：',
          // '陶耿|国泰君安资管副董事长、总裁',
          // '代军|富滇银行董事长',
          // '郭健|招商局资本总董事、首席执行官',
          // '鲍文革|南方基金督察长',
          // '蒋松荣|华福证券副总裁'
        ]
      },
      {
        time: '15:15-16:15',
        title: '圆桌讨论：绿色金融的创新实践与挑战',
        list: [
          '主持|：',
          '刘夏|云核变量集团董事长、皓宁云核资本创始合伙人',
          '嘉宾|：',
          '白剑龙|富滇银行股份有限公司党委委员、副行长（拟任）、董事会秘书',
          '沈春晖|红塔证券股份有限公司总裁',
          '蒋松荣|华福证券有限公司党委委员、副总裁',
          '冯红涛|招商局资本副总经理、执委会委员'
        ]
      },
      {
        time: '16:15-17:15',
        title: '圆桌讨论：绿色转型与产业低碳可持续发展',
        list: [
          '主持|：',
          '彭澎|中国新能源电力投融资联盟秘书长、GF60专家委员',
          '嘉宾|：',
          '张正基|云铝股份有限公司董事长',
          '郭俊梅|贵研铂业董事长',
          '周文明|上海中路集团总裁',
          '李锦|中建科创（上海）投资有限公司副总经理'
        ]
      },
      {
        time: '17:15-17:30',
        title: 'GF60绿色金融奖评选介绍与颁奖活动',
        list: ['GF60合作交流中心主任程亚雷介绍绿色金融奖评选机制', '最佳金融机构案例与最佳创新实践案例结果公布']
      },
      {
        time: '17:30',
        title: '会议结束'
      }
    ]
  };
 */
export const meetingList = {
  am: [
    {
      time: '08:00-08:30',
      title: '嘉宾签到'
    },
    {
      time: '08:30-09:00',
      title: '开幕致辞',
      list: ['云南省人民政府领导致辞', '昆明市委领导致辞', '昆明市人民政府领导致辞']
    },
    {
      time: '09:00-10:30',
      title: '主旨演讲',
      list: [
        '刘明康|GF60学术委员会委员、原中国银监会主席',
        '陈四清|中国工商银行党委书记、董事长',
        '谷澍|中国农业银行党委书记、董事长',
        '郭承站|中国环境保护产业协会党委书记、会长',
        '黄震|中国工程院院士、上海市政协副主席',
        '刘元春|上海财经大学校长',
        '孙念瑞|中国上市公司协会党委委员、副会长'
      ]
    },
    {
      time: '10:30-10:45',
      title: '茶歇',
      needAlign: true,
    },
    {
      time: '10:45-12:15',
      title: '主旨演讲',
      list: [
        '刘建军|中国邮储银行行长',
        '徐玉长|中国经济信息社党委书记、董事长、总裁',
        '刘逖|上海证券交易所副总经理',
        '李辉|深圳证券交易所副总经理',
        '张旻|兴业银行副行长',
        '赖晓明|上海环境能源交易所董事长',
        '何海峰|国泰君安首席经济学家'
      ]
    },
    {
      time: '12:15-14:00',
      title: '午餐',
      needAlign: true,
    }
  ],
  pm: [
    {
      time: '14:00-14:20',
      title: '指数及行业报告发布',
      list: ['中国首支泛行业气候投融资指数发布仪式', 'GF60首席经济学家张俊杰解读指数编制报告']
    },
    {
      time: '14:20-15:40',
      title: '主旨演讲与圆桌讨论一：绿色金融的创新实践与挑战',
    },
    {
      title: '主旨演讲',
      list: ['王海璐|工银理财董事长', '张宏良|交银理财董事长']
    },
    {
      title: '圆桌讨论',
      list: [
        '主持|：',
        '尹彬彬|GF60绿色金融业务委员会主任',
        '嘉宾|：',
        '陶耿|国泰君安资管副董事长、总裁',
        '代军|富滇银行董事长',
        '郭健|招商局资本总董事、首席执行官',
        '鲍文革|南方基金督察长',
        '蒋松荣|华福证券副总裁'
      ]
    },
    {
      time: '15:40-15:50',
      title: '茶歇',
      needAlign: true,
    },
    {
      time: '15:50-17:10',
      title: '主旨演讲与圆桌讨论二：绿色转型与产业低碳可持续发展'
    },
    {
      title: '主旨演讲',
      list: ['景嵩|兴银理财董事长', '刘军|建信基金董事长']
    },
    {
      title: '圆桌讨论',
      list: [
        '主持|：',
        '张俊杰|GF60首席经济学家',
        '嘉宾|：',
        '马洪杰|神州信息副总裁',
        '邬品芳|国富氢能董事长',
        '周文明|上海中路集团总裁',
        '高贵超|云南铜业董事长',
        '张文学|云天化集团董事长'
      ]
    },
    {
      time: '17:10-17:20',
      title: '昆明市双碳基金启动仪式'
    },
    {
      time: '17:20-17:45',
      title: 'GF60绿色金融案例评选机制介绍与颁奖活动',
      list: ['GF60绿色金融业务委员会主任尹彬彬介绍评选机制', '最佳金融机构案例与最佳创新实践案例结果公布']
    },
    {
      time: '17:45-17:50',
      title: '主持人宣布大会碳排放中和方案，会议结束'
    }
  ]
};
export const footerList = [
  {
    tit: '主办单位',
    list: ['昆明市人民政府', '绿色金融60人论坛']
  },
  {
    tit: '支持单位',
    list: ['中国上市公司协会']
  },
  {
    tit: '承办单位',
    list: ['昆明市人民政府金融办公室'],
    list2: ['上海金司南金融研究院', '昆明产业开发投资有限责任公司']
  },
  {
    tit: '战略媒体',
    list: ['新华财经', '昆明日报', '昆明电视台']
  },
  {
    tit: '合作单位',
    list: ['中国资本市场50人论坛', '岭南论坛', '商汤科技', '神州信息']
  }
];

export const navList = [
  {
    tit: '峰会动态',
    ele: 'ldzc'
  },
  {
    tit: '主旨演讲',
    ele: 'zzyj'
  },
  {
    tit: '圆桌论坛',
    ele: 'yzlt'
  },
  {
    tit: '气候指数',
    ele: 'qhzs'
  },
  {
    tit: '绿金评选',
    ele: 'ljpx'
  },
  {
    tit: '精彩图集',
    ele: 'jctj'
  }
];

export const smaNavList = [
  {
    tit: '评选动态',
    ele: 'pxdt'
  }, {
    tit: '获奖名单',
    ele: 'hjmd'
  }, {
    tit: '现场视频',
    ele: 'xcsp'
  }, {
    tit: '精彩图集',
    ele: 'jctj'
  }
];

export const ldzcList = [
  {
    title: '2022绿色金融国际峰会·滇池论坛开幕在即 现场将发布多项绿色领域成果',
    date: '2022-12-21',
    source: 'GF60公众号 ',
    imgUrl: 'https://gf60.org.cn/upload/owe/cfb23454466744fd879e41b6ec930ef9.jpeg',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247496865&idx=1&sn=78d1e987200d437e31cfc118dda77ecd&chksm=cece1788f9b99e9e32ccb4ba64cd7d98d4dd6964350c6774c975f03154b91724ed823951cfcc&token=116680869&lang=zh_CN'
  },
  {
    title: '2022绿色金融国际峰会·滇池论坛成功举办',
    date: '2022-12-23',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/2d2cbffc048a43209fe8cd591f17b1aa.png',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247496927&idx=1&sn=aa0482a896e5eeb1f0823386f52bc839&chksm=cece17f6f9b99ee0c78ad9ee20799c7db1cd032d72be48f46b31e8bb460c9ed8a1bf5c6d19e6&token=116680869&lang=zh_CN'
  }
];

export const zzyjList = [
  {
    title: '刘明康：齐心合力为建设美丽云南的新篇章而共同努力',
    date: '2022-12-25',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/048cc12800954a229fa8ed45aee01239.jpeg',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247496955&idx=1&sn=95787fec78515a4a9f558e335eb67bc3&chksm=cece17d2f9b99ec4313aa37ba4dfcada7b5015efb7a43f0e1d42649f3bb86f2c403a1a38714b&token=811970136&lang=zh_CN'
  },
  {
    title: '工行董事长陈四清：推动绿色金融发展 为建设美丽中国提供更强大金融助力',
    date: '2022-12-28',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/ccf7f415e2be4edbbdee4b258d662528.jpeg',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247497023&idx=1&sn=9a97be0cd0b4205e49e53ce7eb300fd9&chksm=cece1616f9b99f008c3cde627c4c60a75766836c2830e94c27ccb12f439854bf27744c606d0b&token=811970136&lang=zh_CN'
  },
  {
    title: '工银理财董事长王海璐：三管齐下助力绿色资管市场健康发展',
    date: '2022-12-28',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/cc44357518a74ee28a4c40a06e916088.jpeg',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247497023&idx=2&sn=27ba4d96303eef2b765107ebbcd622c9&chksm=cece1616f9b99f00c9d2b78d81b79905d245a9425227bec90d5b51dd62bc0af7342d3a38d400&token=811970136&lang=zh_CN'
  },
  {
    title: '中国工程院院士黄震：碳中和下的能源绿色转型呈现四大特征',
    date: '2022-12-28',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/f85a105e39f94e3cbeec909ed2914508.png',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247497110&idx=1&sn=fcdc732f96496397b2a40c3f1db7f55e&chksm=cece16bff9b99fa9885f3af348c8ff2afcfe10abd079fed508108d1c1598df4c37ac87570e54&token=811970136&lang=zh_CN'
  }, 
  {
    title: '上海财经大学校长刘元春：促进能源结构革命性提升 绿色转型将助推中国经济高质量发展',
    date: '2022-12-30',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/64af952fc5ca49c4b2875beaf21a3c59.jpeg',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247497131&idx=1&sn=55730a60bf9d9e2dc58ffa839219f8a3&chksm=cece1682f9b99f94f613185c230e51c22fa3fb035b8d0a3568dbbcbd71502405bb3a572d811b&token=811970136&lang=zh_CN'
  },
  {
    title: '银保监会国际合作与外资机构监管部主任廖媛媛：扩大银行业保险业开放 助推区域性金融中心建设',
    date: '2023-01-03',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/2357ead228df4570b0a11a46bfd1f250.jpeg',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247497159&idx=1&sn=9999b78d1a47bc59bae33d5c9307fe30&chksm=cece16eef9b99ff8eece732ff25ca18206bfd40f61c485c26df92dd38aad65766e61df9e7a9b&token=811970136&lang=zh_CN'
  },
  {
    title: '深交所副总经理李辉：提升低碳可持续产业优质企业直接融资效能',
    date: '2023-01-03',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/c4e6215290a54ab09f35a8ca91c14cc9.jpeg',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247497159&idx=2&sn=15c5204e872a851f6e22b406add46051&chksm=cece16eef9b99ff8f075d7b84eadd59546e0833495d2d47cdaa327439403455b802dbbd2febe&token=811970136&lang=zh_CN'
  },
  {
    title: '上海市政府参事、上海银保监局原一级巡视员张光平：科技是人民币国际化和绿色金融的重要驱动力',
    date: '2023-01-04',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/13addc39b3674b65bcc7ca8511f614d7.jpeg',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247497181&idx=1&sn=69a102f562be3e6ea327d5ab690e731b&chksm=cece16f4f9b99fe28ce094e81879ba59d95e210ee52ec36a893236fbab8ad3dc6f7b33dd9e01&token=811970136&lang=zh_CN'
  },
  {
    title: '农行副行长张旭光：以金融之力，绘就生态底色',
    date: '2023-01-05',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/983297adc37f4860b917461a7c786d36.png',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247497198&idx=1&sn=e0efe77463d990dc9f143e4cca962373&chksm=cece16c7f9b99fd1778c225b0acdd715cb5d9fd37758dcb38c1d0f759157e3c695b96a335254&token=811970136&lang=zh_CN'
  },
  {
    title: '农银理财总裁段兵：共同推动制定行业绿色投资标准，确保绿色金融可持续发展',
    date: '2023-01-05',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/8f6e342c03d64b76b1a6d618ec42c0da.jpeg',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247497198&idx=2&sn=c336ebfe96f4798c77dcc5e880842978&chksm=cece16c7f9b99fd131c5eb0fcdf1e5c69f11981ab270b20976100493e866c523c3113b897f0e&token=811970136&lang=zh_CN'
  },
  {
    title: '国泰君安首席经济学家何海峰：证券行业可在五大领域为绿色低碳发展做出独特贡献',
    date: '2023-01-06',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/6cc2c4f3dbf6461eb81cfdaa071d766b.jpeg',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247497227&idx=1&sn=7ac87c6c884ec79fbfab49502e7870d0&chksm=cece1522f9b99c34de81758619ef52eb93087020b22903baa12b0951ee8d130055e75537081b&token=811970136&lang=zh_CN'
  },
  {
    title: '中上协副会长孙念瑞：上市公司ESG信批水平不断提升 助力实现绿色高质量发展',
    date: '2023-01-07',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/639da749e2504ca2898c45a88c80221c.png',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247497258&idx=1&sn=7af10387460e70afa42fe7fa81aa9df2&chksm=cece1503f9b99c15ad53ccf0a8d8dd1b42bb22fc59cb3221938139fec1fb24a777bb043b24b6&token=811970136&lang=zh_CN'
  },
  {
    title: '中国邮储银行副行长杜春野：大力发展绿色金融 助力绿色低碳转型',
    date: '2023-01-07',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/507eca08d75149a5ac8fbc0654ba900f.png',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247497258&idx=2&sn=08dddccb622d2a7d89147729c9c3c54b&chksm=cece1503f9b99c1577b6cd690b6b10d83f65cde435ef342f2589db0fa1eaf6a7bcb171a31541&token=811970136&lang=zh_CN'
  }
];

export const qhzsList = {
  title: '“中证金司南气候友好主题指数”由中证指数有限公司、上海金司南金融研究院共同研究开发，是国内首支以“气候友好”命名的绿色主题指数。指数首次全面纳入“减缓”“适应”两大应对气候变化行动领域上市公司证券，并选取沪深市场清洁能源、绿色交通、绿色建筑、生态修复等深度低碳领域100只股票作为样本，旨在更好地发挥气候投融资对市场的正向引领效应，为经济绿色低碳转型提供更多助力。',
  banner: 'https://gf60.org.cn/upload/owe/ffe48e169b7540ae960c7ed78403d8fd.jpg',
  list: [
    {
      title: '全面把握气候投资机遇 中证金司南气候友好主题指数正式发布',
      date: '2022-12-23',
      source: 'GF60公众号',
      imgUrl: 'https://gf60.org.cn/upload/owe/908e68dd2ce94048b8e100fb114f5f03.jpeg',
      link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247496927&idx=2&sn=f8f4d8a574813b86bd4f8f11304cebf6&chksm=cece17f6f9b99ee06ff7e511d4074dd14daf50b8a3606307b9fd280ac8a90585098a94cb9329&token=116680869&lang=zh_CN'
    },
    {
      title: '气候投融资热潮催生投资机遇 国内首支气候友好主题指数正式发布',
      date: '2022-12-25',
      source: 'GF60官网 ',
      imgUrl: 'https://gf60.org.cn/upload/owe/667293ce97ea40f3b7b48897d39ca5cc.jpeg',
      link: 'https://gf60.org.cn/pc/detail/63c0feb1c4f1571ef252af9d?lang=zh'
    },
    {
      title: '一张图了解什么是中证金司南气候友好主题指数？',
      date: '2022-12-26',
      source: 'GF60公众号',
      imgUrl: 'https://gf60.org.cn/upload/owe/713a5f281ed7401d888b9fe3c81b172b.png',
      link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247496955&idx=2&sn=1ab827156e9589178dbe4f04d88ee884&chksm=cece17d2f9b99ec405c9c0a0e77b20c49425aad168a8b0f08c49f6460c8d4a13c8ade8ccdab5&token=116680869&lang=zh_CN'
    },
  ]
};

export const ljpxList = [
  {
    title: 'GF60绿色金融奖榜单正式发布 两大奖项重磅揭晓',
    date: '2022-12-22',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/7f03880775154f7dbdb08bbb72f8a980.jpeg',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247496927&idx=3&sn=8fdf23837ecb75a7050ace660513f683&chksm=cece17f6f9b99ee0d53d95df177182a8990bdf5a217ea8f3ac8a2f9ecce3813416abe86e5a46&token=116680869&lang=zh_CN'
  },
  {
    title: '以行动样本绘就绿色蓝图——GF60绿色金融奖获奖案例详解',
    date: '2022-12-22',
    source: 'GF60公众号',
    imgUrl: 'https://gf60.org.cn/upload/owe/efd86ec7da564aa2913c6144cdf71738.jpeg',
    link: 'https://mp.weixin.qq.com/s?__biz=Mzg3NDcwNjUwMg==&mid=2247497131&idx=2&sn=cfd62c51b7803138e5ca023062b462f0&chksm=cece1682f9b99f9407b10e63f465006876bbf159a7953a79fcd8e1ad720f9e5382ac9c542e1a&token=116680869&lang=zh_CN'
  }
];

export const yzltList = [
  {
    title: '圆桌论坛一：绿色金融的创新实践与挑战',
    subTittle1: '主持人：云核变量集团董事长刘夏',
    subTittle2:'参与嘉宾：富滇银行党委书记、副行长白剑龙（拟任），红塔证券总裁沈春晖，华福证券党委委员、副总裁蒋松荣，招商局资本副总经理冯红涛',
    banner: 'https://gf60.org.cn/upload/owe/7c7165178c24440ba15119cde3c15a0d.jpg',    
  },
  {
    title: '圆桌论坛二：绿色转型与产业低碳可持续发展',
    subTittle1: '主持人：中国新能源电力投融资联盟秘书长彭澎',
    subTittle2:'参与嘉宾：云铝股份党委书记、董事长张正基，贵研铂业董事长郭俊梅，上海中路集团总裁周文明，中建科创（上海）投资有限公司副总经理李锦',
    banner: 'https://gf60.org.cn/upload/owe/77937868616e4855a852576b39bdd91d.jpg',
  }
];

export const ljpxData = {
  title: ' “GF60绿色金融奖”评选活动由绿色金融60人论坛发起主办，旨在遴选优秀的绿色金融机构与案例，为绿色金融发展提供示范样本，鼓励持续探索绿色金融发展与创新，引导加大绿色产业的资金支持力度，让绿色金融更好助力经济社会绿色低碳高质量发展。',
  banner: 'https://gf60.org.cn/upload/owe/fdc2247d39a043ca94b91ebf96437cfa.jpg',
}

export const videoList = [
  'blob:https://tv.cctv.com/3979536a-b277-4257-b89d-f538964e0e70'
]

export const imgList = [
'https://gf60.org.cn/upload/owe/b8fd08cdc5f94c65806b61686ac2362a.jpg',
'https://gf60.org.cn/upload/owe/7808283b74674a71ab8aeecb42b1cd0b.jpg',
'https://gf60.org.cn/upload/owe/7d7d293f9f294db6be22ba606428deac.jpg',
'https://gf60.org.cn/upload/owe/569ce43aaab6420d92fa238058d1ca63.jpg',
'https://gf60.org.cn/upload/owe/ac00d66b87c94f10a97434724f809fc4.jpg',
'https://gf60.org.cn/upload/owe/bdf699bea609431aae40445f393a6eca.jpg',
'https://gf60.org.cn/upload/owe/4ca3b3e142f44661b7c43538bf4720e4.jpg',
'https://gf60.org.cn/upload/owe/5e41ec26fc9641bcb01d4c544acf054f.jpg',
'https://gf60.org.cn/upload/owe/0625055f63a24fa78dd105ffed331d2b.jpg',
'https://gf60.org.cn/upload/owe/d4358806902c4b28a0cdda7107410ff1.jpg',
'https://gf60.org.cn/upload/owe/09a5c73e964647619651f56180ee1b40.jpg',
'https://gf60.org.cn/upload/owe/3af5b0940b584a30a2c07bcfe299896b.jpg',
'https://gf60.org.cn/upload/owe/daa328c10e8b41498ad6a11ed27e4087.jpg',
'https://gf60.org.cn/upload/owe/823f4dc5f4e44e8d8109764c05ccc67f.jpg',
'https://gf60.org.cn/upload/owe/f775c6d046ee4c9098dded26a1e719d9.jpg',
'https://gf60.org.cn/upload/owe/558e59dc840047ab89f14d67ce7d3a94.jpg',
'https://gf60.org.cn/upload/owe/6366cc99e48d4803b1b45b67228b77a0.jpg',
'https://gf60.org.cn/upload/owe/84eeeb85ab26426fb4a62aca14898d1f.jpg',
'https://gf60.org.cn/upload/owe/433d40a6b38c4d86ba8fa804f8449d6e.jpg',
'https://gf60.org.cn/upload/owe/8f9f10fe50b64ebeac68ee2ca8f0893c.jpg',
'https://gf60.org.cn/upload/owe/b858c66c7e104f40a832a23821d667fb.jpg',
'https://gf60.org.cn/upload/owe/b4a3d929129c4cdab4a0d4837be15595.jpg',
'https://gf60.org.cn/upload/owe/e54d9735ac434ac4baaf0c34e7a498cd.jpg',
'https://gf60.org.cn/upload/owe/6838b16b8ec74559b9f453b81ee28406.jpg',
'https://gf60.org.cn/upload/owe/cb2dc76e7c6046b5843cc45f178230e6.jpg',
'https://gf60.org.cn/upload/owe/ff940c38369d497a949de114c730c3a8.jpg',
'https://gf60.org.cn/upload/owe/507717a0d2b94f5ba306b151423bd030.jpg',
'https://gf60.org.cn/upload/owe/d91c4bef407a46daabcafca69f5a56a3.jpg',
'https://gf60.org.cn/upload/owe/cdce3a0defa048e8a06a0847a236a39a.jpg',
'https://gf60.org.cn/upload/owe/eb254eef554847989c9778f651efc0cd.jpg',
'https://gf60.org.cn/upload/owe/b6122b04889041f483e31d6f2e97042e.jpg',
'https://gf60.org.cn/upload/owe/26239a140f6f45bba34e33b9fd5242b7.jpg',
'https://gf60.org.cn/upload/owe/c77617712d2546a8856f9a35b6a42f4c.jpg',
'https://gf60.org.cn/upload/owe/ea65f90ff1d1497dac60d301c1cfb22e.jpg',
'https://gf60.org.cn/upload/owe/b2c87428bea44b60a5d30d93ed11105a.jpg',
'https://gf60.org.cn/upload/owe/3de0ea7074b14bfdb3fed95af4c18c34.jpg',
'https://gf60.org.cn/upload/owe/f5e83e78ca2a46d08d01a5114970e6ee.jpg',
'https://gf60.org.cn/upload/owe/4679d9cbee604d0482781980b2b05e31.jpg',
'https://gf60.org.cn/upload/owe/5b760f44df3945308f0600407afc71e0.jpg'
];

export const awardImgs = [
  [
    'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Finews.gtimg.com%2Fnewsapp_bt%2F0%2F14415837819%2F1000&refer=http%3A%2F%2Finews.gtimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1671937917&t=bbfc1d693da1ef2bee9b88d2a9b5e0f9',
    'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fhbimg.b0.upaiyun.com%2Fd554edea02dafcda87fa49eb21b07aef48b1aca65317e-FgkKrX_fw658&refer=http%3A%2F%2Fhbimg.b0.upaiyun.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1671936539&t=023e6bec7d5f8cb6164bb6ce412982c1',
    'https://gf60.org.cn/upload/owe/9ed7b7703380490d872f4301b6bd7b50.jpg',
    'https://gf60.org.cn/upload/owe/03a2555234c54432975ec9d24527bd28.jpeg',
    'https://gf60.org.cn/upload/owe/56c5ba17567349139e323e45ecb7ad36.jpeg',
    'https://gf60.org.cn/upload/owe/757c907df69541a2833181a187f7a52b.jpeg'
  ],
  [
    'https://gf60.org.cn/upload/owe/5d8c673757e64524aa57f76fcfada788.jpeg',
    'https://gf60.org.cn/upload/owe/4b2538df855342fd8adb802941cd344b.jpeg',
    'https://gf60.org.cn/upload/owe/107fe7a7daa14016961e7e7611353316.jpeg',
    'https://gf60.org.cn/upload/owe/2ef11c2e614344debb0d5a36c2487c01.jpeg',
    'https://gf60.org.cn/upload/owe/89dec94187ac4ad6bf52964c74cb17de.jpeg',
    'https://gf60.org.cn/upload/owe/03a2555234c54432975ec9d24527bd28.jpeg',
  ],
  [
    'https://gf60.org.cn/upload/owe/757c907df69541a2833181a187f7a52b.jpeg',
    'https://gf60.org.cn/upload/owe/5d8c673757e64524aa57f76fcfada788.jpeg',
    'https://gf60.org.cn/upload/owe/4b2538df855342fd8adb802941cd344b.jpeg',
    'https://gf60.org.cn/upload/owe/107fe7a7daa14016961e7e7611353316.jpeg',
    'https://gf60.org.cn/upload/owe/2ef11c2e614344debb0d5a36c2487c01.jpeg',
    'https://gf60.org.cn/upload/owe/89dec94187ac4ad6bf52964c74cb17de.jpeg',
  ],
  [
    'https://gf60.org.cn/upload/owe/03a2555234c54432975ec9d24527bd28.jpeg'
  ]
];

// 金融机构
export const zjjrjg = [
  '国泰君安证券股份有限公司',
  '杭州银行股份有限公司',
  '华夏理财有限责任公司',
  '江苏银行股份有限公司',
  '南方基金管理股份有限公司',
  '上海国际信托有限公司',
  '苏州银行股份有限公司',
  '兴业银行股份有限公司',
  '中国工商银行股份有限公司',
  '中国民生银行股份有限公司'
];

// 时间创新
export const zjcxsj = [
  '长安银行股份有限公司',
  '华泰证券（上海）资产管理有限公司',
  '华夏基金管理有限公司',
  '湖北银行股份有限公司',
  '嘉实基金管理有限公司',
  '江苏江南农村商业银行股份有限公司',
  '南京银行股份有限公司',
  '上海农村商业银行股份有限公司',
  '上海市水利工程集团有限公司',
  '神州数码信息服务股份有限公司',
  '苏州银行股份有限公司',
  '厦门航空有限公司',
  '信银理财有限责任公司',
  '中国财产再保险有限责任公司',
  '中国邮政储蓄银行莆田市分行'
];

